import Cookies from 'js-cookie';

import { datadogLogs } from '@datadog/browser-logs';

export const SESSION_COOKIE_NAME = 'handshake-session';
export const AUTH_CODE_QUERY_PARAM = 'code';

const COOKIE_DELIMITER = '@';

export const getSessionToken = () => {
  const cookie = Cookies.get(SESSION_COOKIE_NAME)?.split(COOKIE_DELIMITER);

  if (cookie?.length === 2) {
    return {
      token: cookie[0],
      enquiryId: Number(cookie[1]),
    };
  }

  return {};
};

export const setSessionToken = ({ token, enquiryId }: { token: string; enquiryId: number }) => {
  Cookies.set(SESSION_COOKIE_NAME, `${token}${COOKIE_DELIMITER}${enquiryId}`, {
    expires: new Date(Date.now() + 4 * 60 * 60 * 1000),
    secure: true,
    sameSite: 'strict',
    path: '/',
  });
};

export const clearSessionToken = () => {
  Cookies.remove(SESSION_COOKIE_NAME, { path: '/' });
};

export const getVehicleQueryParams = () => {
  const url = new URL(window.location.href);
  const params = url.searchParams.get('params');

  if (params) {
    try {
      const basicVehicleParams = JSON.parse(atob(params)) as [string, string, string, number | string];
      if (Array.isArray(basicVehicleParams) && basicVehicleParams.length === 4) {
        const [, , , enquiryId] = basicVehicleParams;
        const params = basicVehicleParams.with(-1, Number(enquiryId));

        datadogLogs.setGlobalContextProperty('enquiryId', params[3]);

        return params;
      }
    }
    catch (error: unknown) {
      datadogLogs.logger.error('Failed to parse query params', {}, new Error(String(error)));
    }
  }

  return null;
};
